import { PageHeader } from "@justworkshr/milo-core";
import { buildWebPath } from "lib/resource-finder";
import styles from "./EditableProfileHeader.module.css";
import { SystemIcon } from "@justworkshr/milo-icons";
import { useTranslation } from "react-i18next";

type Props = {
  linkToProfile: string;
  title: string;
};

export default function EditableProfileHeader({ linkToProfile, title }: Props) {
  const { t } = useTranslation();

  // For external URLs (Neon), use as-is; for internal paths, prepend /cf/ and let buildWebPath handle it
  const href = linkToProfile.startsWith("http")
    ? linkToProfile
    : buildWebPath(`/cf${linkToProfile}`);

  return (
    <PageHeader
      linkPrevious={
        <a href={href}>
          <div className={styles.backContainer}>
            <SystemIcon iconName="arrow-left" color="brand" size="small" />
            <span>{t("Back to Profile")}</span>
          </div>
        </a>
      }
      title={title}
    />
  );
}
